import trackingChannelsConfig from 'root/utils/tracking/tracking_channels_config';
import { LoggingHandler } from 'root/utils/errorReporting/LoggingHandler';
import channelsCallbackGroup from 'root/utils/tracking/channelsCallbackGroup';

// @todo This is to be deleted after all instances have been replaced with the new function below
const GoogleTagManagerDeprecated = function (options = {}) {
    this.options = options;
};
GoogleTagManagerDeprecated.prototype = {
    sendEvent(eventName, eventCategory, eventAction, eventLabel, eventValue = undefined) {
        if (typeof dataLayer !== 'undefined') {
            dataLayer.push({
                event: eventName,
                eventCategory: eventCategory,
                eventAction: eventAction,
                eventLabel: eventLabel,
                eventValue: eventValue,
                nonInteraction: true,
            });
        }
    },
};

const logErrorDetailsObj = {
    tags: ['gtm-tracking'],
    fileName: 'googleTagManagerDeprecated.js',
    additionalData: {
        location: window.location,
    },
};

const gtm = (() => {
    const channelsObjectConstructor = channelsCallbackGroupFunction => {
        const reconstructedObject = {};
        if (trackingChannelsConfig && typeof trackingChannelsConfig === 'object') {
            for (let [key, value] of Object.entries(trackingChannelsConfig)) {
                if (typeof channelsCallbackGroupFunction === 'function') {
                    const { callbackName } = value;
                    const callback = channelsCallbackGroupFunction()[callbackName];
                    if (typeof callback === 'function') {
                        reconstructedObject[key] = callback(
                            value.eventCategory,
                            value.eventLabel
                        );
                    } else {
                        logErrorDetailsObj.searchTerm = 'channel-callback-error';
                        LoggingHandler().logError(
                            `This ${value.callback} does not exist in the js file.`,
                            logErrorDetailsObj
                        );
                    }
                }
            }
        } else {
            logErrorDetailsObj.searchTerm = 'gtm-json-config-error';
            logErrorDetailsObj.additionalData = {
                trackingChannelsConfig,
            };
            LoggingHandler().logError(
                'The tracking channels config does not exist or is the wrong type',
                logErrorDetailsObj
            );
        }

        return reconstructedObject;
    };

    return channelsObjectConstructor(channelsCallbackGroup);
})();

export { GoogleTagManagerDeprecated, gtm };
